// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gS","advertCardHeader__actions":"c-a_gT","advertCardHeader__bottomLabel":"c-a_gU"};